import React, { useState } from "react";
import { useLocation } from "react-router-dom";
import Navbar from "../shared/Navbar";

const RouteHandler = ({ excludeLayout, children }) => {
  const location = useLocation();
  const excludeLayoutFlag = !excludeLayout.includes(location.pathname);
  const [collapsed, setCollapsed] = useState(false);

  return (
    <div style={{ display: "flex" }}>
      {excludeLayoutFlag && (
        <Navbar collapsed={collapsed} setCollapsed={setCollapsed} />
      )}
      <div
        style={{
          flexGrow: 1,
          marginLeft: excludeLayoutFlag ? (collapsed ? "72px" : "220px") : "0",
          backgroundColor: "white",
          minHeight: "100vh",
          padding: "20px"
        }}
      >
        {children}
      </div>
    </div>
  );
};

export default RouteHandler;
